import { render, staticRenderFns } from "./FormInputDropdown.vue?vue&type=template&id=b71d7a8a"
import script from "./FormInputDropdown.vue?vue&type=script&lang=js"
export * from "./FormInputDropdown.vue?vue&type=script&lang=js"
import style0 from "./FormInputDropdown.vue?vue&type=style&index=0&id=b71d7a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports